<template>
  <table>
    <tbody>
    <tr v-for="partQuantity in value" :key="partQuantity.id">
      <td class="pr-3">{{partQuantity.part | part}}</td>
      <td class="right">{{partQuantity.quantity }} {{partQuantity.part.trackingUnit.unit | unit}}</td></tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'PartQuantitiesView',
  props: {
    value: {
      type: Array,
      validator: value => value.every((partQuantity) => partQuantity.part && partQuantity.part.id &&  'quantity' in partQuantity),
    },
  },
};
</script>
<style scoped>
.preformatted-text-view{
  max-width: 50em;
  white-space: pre-line;
}
</style>
